export default __webpack_public_path__ + "static/media/infokom_icon.993357f0.jpg";